// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { TvBaseFormatter } from './TvBaseFormatter';
export class TvPriceFormatter extends TvBaseFormatter {
    constructor(symbol, alignToMinMove = false) {
        super(symbol);
        this.alignToMinMove = alignToMinMove;
    }
    format(value) {
        if (this.instrument)
            return this.instrument.formatPrice(value);
        return value.toString();
    }
}
